module.exports = __webpack_public_path__ + "static/fonts/Poppins-Thin.9ec2636.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Thin.ttf
// module id = 1035
// module chunks = 11